import { render, staticRenderFns } from "./uploadViewer.vue?vue&type=template&id=1224f452&scoped=true&"
import script from "./uploadViewer.vue?vue&type=script&lang=js&"
export * from "./uploadViewer.vue?vue&type=script&lang=js&"
import style0 from "./uploadViewer.vue?vue&type=style&index=0&id=1224f452&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224f452",
  null
  
)

export default component.exports